import * as React from "react";
import Grid from "@mui/material/Grid";
import PhonelinkSetupIcon from "../../assets/icons/global-icon-manage-devices-black.svg";
import HelpIcon from "../../assets/icons/global-icon-help-black.svg";
import WelcomeCard from "./WelcomeCard";
import SkeletonComp from "app/common/skeleton";
import Tooltip from "app/common/Tooltip";
import { useNavigate } from "react-router-dom";
import { ComponentsContent } from "../common/NumberCard/NumberCardContent";

export default function HeaderSection(props: any) {
  const { loading, firstName, email } = props;
  const router = useNavigate();
  const manageDeviceRef = React.useRef() as React.MutableRefObject<
    HTMLInputElement
  >;
  const helpDigitsRef = React.useRef() as React.MutableRefObject<
    HTMLInputElement
  >;
  const content = ComponentsContent?.Home;
  const handleClickOpen = () => {
    router("/manage-devices");
  };
  const handleClickContact = () => {
    window.open(content.helpWithDigits, "_blank");
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (event.keyCode === 13) {
      ele.current.click();
    }
  };

  return (
    <React.Fragment>
      <Grid className="mblHeader">
        <Grid item lg={7} className="welcomeName">
          <WelcomeCard
            name={firstName}
            email={email}
            showSkelton={loading}
          />
        </Grid>
        <Grid item lg={5} className="topright">
          <SkeletonComp
            loadData={{
              loading: loading,
              height: 50,
              width: 212,
              className: "sPrimaryText",
            }}
          >
            <div className="PrimaryTxt" onClick={handleClickOpen}>
              {" "}
              <img
                src={PhonelinkSetupIcon}
                alt={"Manage"}
                width="24px"
                height="24px"
              />
              <Tooltip
                title="Manage your sign in instances"
                placement="bottom"
                tabIndex={0}
              >
                <span
                  aria-label="Manage your sign in instances"
                  tabIndex={0}
                  onKeyUp={(event) => handleKeyUp(event, manageDeviceRef)}
                  ref={manageDeviceRef}
                >
                  {" "}
                  <span aria-hidden="true"> {"Manage signed in devices"}</span>
                </span>
              </Tooltip>
            </div>
          </SkeletonComp>
          <SkeletonComp
            loadData={{
              loading: loading,
              height: 50,
              width: 212,
              className: "shelpDigit",
            }}
          >
            <div className="PrimaryTxt helpDigit" onClick={handleClickContact}>
              {" "}
              <img src={HelpIcon} alt={"help"} width="24px" height="24px" />
              <Tooltip
                title="Get answers to your DIGITS questions"
                placement="bottom"
                tabIndex={0}
              >
                <span
                  aria-label="Get answers to your DIGITS questions"
                  tabIndex={0}
                  onKeyUp={(event) => handleKeyUp(event, helpDigitsRef)}
                  ref={helpDigitsRef}
                >
                  {" "}
                  <span aria-hidden="true">{"Help with DIGITS"}</span>
                </span>
              </Tooltip>
            </div>
          </SkeletonComp>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
